import { type PresenceMotionFn, createPresenceComponent, motionTokens } from '@fluentui/react-motion';

const placeholderMotion: PresenceMotionFn = () => {
  const enterKeyframes = [
    {
      keyframes: [{ opacity: 0 }, { opacity: 1 }],
      duration: motionTokens.durationFaster,
      easing: motionTokens.curveLinear,
    },
    {
      keyframes: [{ transform: 'translateY(10px)' }, { transform: 'translateY(0)' }],
      duration: motionTokens.durationNormal,
      easing: motionTokens.curveDecelerateMid,
    },
  ];
  const exitKeyframes = {
    keyframes: [{ opacity: 1 }, { opacity: 0 }],
    duration: motionTokens.durationFaster,
    easing: motionTokens.curveLinear,
  };

  return {
    enter: enterKeyframes,
    exit: exitKeyframes,
  };
};

export const PlaceholderMotion: ReturnType<typeof createPresenceComponent<{}>> =
  createPresenceComponent(placeholderMotion);
